import { render } from "./ProductCategory.vue?vue&type=template&id=1a38e1c0&scoped=true"
import script from "./ProductCategory.vue?vue&type=script&lang=js"
export * from "./ProductCategory.vue?vue&type=script&lang=js"

import "./ProductCategory.vue?vue&type=style&index=0&id=1a38e1c0&scoped=true&lang=css"

import exportComponent from "D:\\xampp7\\htdocs\\24x7pos\\client\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1a38e1c0"]])

export default __exports__